/**
 * @module NoAvailableJobsMessage
 */
// eslint-disable-next-line no-unused-vars
import React from 'react';
import { STRINGS } from '../helpers/strings';

/**
 * Represents the text for no available jobs message.
 *
 * @returns {React.ReactElement} The NoAvailableJobsMessage component.
 */
export default function NoAvailableJobsMessage() {
  const { title, body } = STRINGS.noAvailableJobsMessage;

  return (
    <>
      <h3 className="mb-tighter">{title}</h3>
      <div dangerouslySetInnerHTML={{ __html: body }} />
    </>
  );
}
